var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "Layer_1_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58,25h-2v-4.298c0-3.574-1.601-6.904-4.391-9.137C49.542,9.911,46.946,9,44.299,9H27.46C26.36,7.776,24.771,7,23,7H7 c-3.309,0-6,2.691-6,6s2.691,6,6,6h16c1.771,0,3.36-0.776,4.46-2h16.839c0.837,0,1.658,0.288,2.312,0.811 c0.883,0.707,1.39,1.76,1.39,2.891V25h-9.597c-1.132,0-2.241,0.389-3.124,1.096l-2.809,2.247C31.941,28.767,31.275,29,30.597,29H24 c-1.302,0-2.402,0.839-2.816,2H19c-1.103,0-2,0.897-2,2h-4.52l-4-5H1v24h7.48l4-5H17c0,1.103,0.897,2,2,2h2.184 c0.302,0.847,0.969,1.514,1.816,1.816V54c0,1.654,1.346,3,3,3h32c1.654,0,3-1.346,3-3v-4h-0.031C62.194,49.088,63,47.641,63,46V30 C63,27.243,60.757,25,58,25z M13,37v-2h4v2H13z M17,39v2h-4v-2H17z M3,30h4v20H3V30z M11,45.649l-2,2.5V31.851l2,2.5V45.649z M13,45v-2h4v2H13z M23,17H7c-2.206,0-4-1.794-4-4s1.794-4,4-4h16c2.206,0,4,1.794,4,4S25.206,17,23,17z M47.859,16.249 C46.853,15.443,45.588,15,44.299,15H28.65c0.223-0.627,0.35-1.298,0.35-2s-0.128-1.373-0.35-2h15.649 c2.195,0,4.348,0.755,6.061,2.126C52.673,14.978,54,17.739,54,20.702V25h-4v-4.298C50,18.96,49.22,17.337,47.859,16.249z M23,32 c0-0.551,0.448-1,1-1h6.597c0.136,0,0.269-0.023,0.403-0.034V49h-7c-0.552,0-1-0.449-1-1V32z M19,33h2v14h-2V33z M59,54 c0,0.551-0.448,1-1,1H26c-0.552,0-1-0.449-1-1v-3h33c0.342,0,0.677-0.035,1-0.101V54z M61,46c0,1.654-1.346,3-3,3H33V30.382 c0.253-0.138,0.494-0.297,0.721-0.478l2.809-2.247C37.059,27.233,37.725,27,38.403,27H58c1.654,0,3,1.346,3,3V46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,47h16V33H43V47z M45,35h12v10H45V35z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 57,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 12,
    x: 43,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 4,
    x: 25,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 4,
    x: 25,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 4,
    x: 25,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 4,
    x: 25,
    y: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,47h6V31h-6V47z M37,33h2v12h-2V33z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.95c2ad5a149c0e2ccf995a1a46c07190.svg";
export { ForwardRef as ReactComponent };